<div id="snackbar" class="{{ type }}" (click)="goTo()">
	<div class="header">
		<div class="header__message">{{ message }}</div>

		<div class="header__close tagmeicon tagmeicon-close" (click)="closeAlert()"></div>
	</div>

	<div class="subtitle" *ngIf="subtitle">{{ subtitle }}</div>
</div>
